import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

function ProductCompareSkeleton() {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-2">
        <Skeleton className="h-8 w-1/3" />
        <Skeleton className="h-6 w-2/3" />
      </div>
      <div className="border border-gray-300 rounded-lg p-6">
        <Skeleton className="h-6 w-1/4 mb-4" />
        <div className="space-y-4">
          <Skeleton className="h-20 w-full" />
          <Skeleton className="h-20 w-full" />
          <Skeleton className="h-20 w-full" />
        </div>
      </div>
    </div>
  );
}

interface ProductCompareLoadingProps {
  isLoading: boolean;
  containerClassName?: string;
}

export default function ProductCompareLoading({
  isLoading,
  containerClassName = "",
}: ProductCompareLoadingProps) {
  if (!isLoading) return null;
  return (
    <div className={cn("flex flex-col gap-6", containerClassName)}>
      <ProductCompareSkeleton />
    </div>
  );
}
